import Address        from "../fundamentals/address/Address";
import Email          from "../fundamentals/email/Email";
import OfficeId       from "./OfficeId";
import OfficeName     from "./OfficeName";
import OfficeNameKana from "./OfficeNameKana";

class Office {
  constructor(
    private readonly _id: OfficeId = new OfficeId(),
    private readonly _name: OfficeName = new OfficeName(),
    private readonly _nameKana: OfficeNameKana = new OfficeNameKana(),
    private readonly _email: Email = new Email(),
    private readonly _address: Address = new Address(),
  ) {
  }

  get id() {
    return this._id;
  }

  get name() {
    return this._name;
  }

  get nameKana() {
    return this._nameKana;
  }

  get email() {
    return this._email;
  }

  get address() {
    return this._address;
  }
}

export default Office;
